module.exports = __webpack_public_path__ + "img/src/components/ListDefaultPhoto/large_no_image.jpg?7e5ff3aa";